finderApp.service('finderGetPath', ['$location', function($location) {
    if (Util.isLessThanIE10()) {
        return function () {
            return $location.absUrl().match('[a-zA-Z]+\:\/\/[a-zA-Z\.\-]+(.+)')[1];
        };
    } else {
        return function () {
            return $location.path();
        };
    }
}]);